export interface ListFilters {
  startDate?: string;
  endDate?: string;
  userId?: string;
  paymentStatus?: string;
  shipmentStatus?: string;
  isVerified?: string;
  isKycVerified?: string;
}
export function listFilterQuery(filters: ListFilters, allowed: Array<keyof ListFilters>): Record<string, string | boolean> {
  const params: Record<string, string | boolean> = {};
  if (filters.startDate && filters.endDate && filters.startDate > filters.endDate) throw new Error("The end date must be on or after the start date.");
  allowed.forEach(key => {
    const value = filters[key]?.trim();
    if (!value) return;
    if (key === "isVerified" || key === "isKycVerified") {
      if (value !== "true" && value !== "false") throw new Error("Select a valid verification filter.");
      params[key] = value === "true";
    } else params[key] = value;
  });
  return params;
}
